import { CellProps } from "components/table";
import { upperFirst } from "utils/string";

export function DataRequestTypeCell({ value }: CellProps) {
  return <>{upperFirst(value.replaceAll("_", " "))}</>;
}
